import React from 'react';
import ReactDOM from 'react-dom';
import './assets/css/style.css';
import Index from './index/index';

ReactDOM.render(
	<Index />,
	document.querySelector("main")
);



// WEBPACK FOOTER //
// ./src/index.js